import { CheckCircle, ExternalLink, XCircle } from "lucide-react";
import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import type { TestStatus } from "./useSsoTestConnection";

interface Props {
  testStatus: TestStatus;
  onTest: () => void;
}

const STATUS_CONFIG: Record<TestStatus, { icon: ReactNode; label: string }> = {
  idle: {
    icon: <ExternalLink className="h-4 w-4 mr-1" />,
    label: "Test Connection",
  },
  testing: {
    icon: null,
    label: "Testing...",
  },
  success: {
    icon: <CheckCircle className="h-4 w-4 mr-1 text-chart-6" />,
    label: "Success",
  },
  error: {
    icon: <XCircle className="h-4 w-4 mr-1 text-destructive" />,
    label: "Failed",
  },
};

export default function TestConnectionButton({ testStatus, onTest }: Props) {
  const { icon, label } = STATUS_CONFIG[testStatus];

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={onTest}
      disabled={testStatus === "testing"}
    >
      {icon}
      {label}
    </Button>
  );
}
